import { Component, OnInit } from '@angular/core';
import { BaseSitesFacade } from '@kion/data-access/data-access-base-sites';
import { CmsConfig } from '../../config/cms.config';
import { Observable } from 'rxjs';
import { BaseSite } from '@kion/data-models';
import { map } from 'rxjs/operators';

@Component({
  selector: 'kion-cms-phone',
  templateUrl: './phone.component.html',
  styleUrls: ['./phone.component.scss']
})
export class PhoneComponent implements OnInit {

  baseSite$: Observable<BaseSite>;

  constructor(private baseSitesFacade: BaseSitesFacade, private cmsConfig: CmsConfig) {
    this.baseSite$ = this.baseSitesFacade.all$.pipe(
      map(
        (baseSites: BaseSite[]) => baseSites.find(
          (baseSite: BaseSite) => baseSite.id === this.cmsConfig.baseSite
        )
      )
    )
  }

  ngOnInit(): void {
  }

}
